import { gql } from '@apollo/client';

const carSpecifications = {
  GET_CAR_SPECIFICATIONS: gql`
    query GetCarSpecifications($carId: CarId!) {
      carSpecifications(carId: $carId) {
        name
        specItems {
          name
          value
          disclaimer
        }
        groupName
        displayOrder
      }
      customizeCar(carId: $carId) {
        car {
          engine {
            attributes {
              brand
              oemcode
              capacity
              shortdescription
              maximumpower
              maximumtorque
              powersystem
              powertrain
              environmentalstandard
              possiblefuels
              environmentalstandarddisclaimer
              transmissionreference
              gearnumbers
              transmission
              relationship1
              relationship2
              relationship3
              relationship4
              relationship5
              relationship6
              relationship7
              relationship8
              relationship9
              relationship10
              relationship11
              reverse1
              reverse2
              reverse3
              reverse
              finalshaftratio
              traction
              grossvehicleweight
              grosscombinedvehicleweight_c2s1
              grosscombinedvehicleweight_c2s2
              grosscombinedvehicleweight_c2s3
              chassisweight
              grossloadcapacity
              frontaxlecapacity
              rearaxlecapacity
              frontsuspensioncapacity
              rearsuspensioncapacity
              offroadaxlecapacity
              fueltank
              bluetank
              slopestartingcapability
              cartercapacity
              tireturningradius
              crewnumber
              cartercapacitydisclaimer
              grossweightdisclaimer
              address
              frontaxlesuspensiontype
              frontaxleshockabsorber
              rearaxlesuspensiontype
              rearaxleshockabsorber
              brakingsystemtype
              nominalvoltage
              alternatorcapacity
              batterynumber
              batterycapacity
            }
          }
          model {
            attributes {
              radio
              doorbrake
              toolkit
              electromagnetic_retarder
              sparerim
              sparetire
              foldingchairs
              hillstartsystem
              idlestop
              cabin
              differentiallock
              airconditioning
              hourmeter
              explorers
              slopeassist
              reversealarm
              fifthwheel
              address
              display
              coolanttemperature
              idlestopdisclaimer
              dimensions_length
              dimensions_width_mirrorsout
              dimensions_height
              dimensions_frontwheeltrack
              rearaxledistance
              dimensions_wheelbase
              dimensions_rearwheeltrack
              loadspace_lengthbehindfirstrow
              wheelsize
              warranty
              distancebetweenaxlesdisclaimer
            }
          }
        }
      }
    }
  `,
};

export default carSpecifications;
